import React, { Component } from 'react';
import { Container, Row, Button, Col } from 'react-bootstrap';

export default class ProjEditNumberDom extends React.Component {
    constructor(props) {
        super(props);

        // this.state = {
        //     value: props.value
        // };
        this.onChange = this.onChange.bind(this);
    }

    onChange(event) {
        let tmp = parseInt(event.target.value);
        if (isNaN(tmp)) {
            alert("請輸入數字");
        } else {
            console.log(event.target.value);
            this.props.onChange(this.props.dataKey, event.target.value);
        }
    }

    render() {
        const { isDisabled, data, value } = this.props;
        // const { value } = this.state;

        if (isDisabled) {
            return (
                <Col className="mb-2">
                    <label>{data.name}</label>
                    <input disabled="disabled" className="form-control" type="text" value={value} />
                </Col>
            );
        } else {
            return (
                <Col className="mb-2">
                    <label>{data.name}</label>
                    <input className="form-control" type="text" value={value} onChange={this.onChange} />
                </Col>
            );
        }
    }
}